module.exports = __webpack_public_path__ + "img/5.3f10f5f6.png";